import * as Guards from './interaction-mode.enum.type.guard'

/** @see {isInteractionMode} ts-auto-guard:type-guard */
export enum InteractionMode {
  NAVIGATION = 'navigation',
  SELECTION = 'selection',
}

export { Guards }
